import { ValidateExistenceService } from '../../../Infrastructure/Services/validate-existence.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
	AllGroupsI,
	Groups,
	StatusUSerGroups,
	StatusUserI,
} from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { GroupsUsers, UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import {
	getAllGroup,
	postUsersGroups,
	updateUsersGroups,
} from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { selectGroupState } from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.selectors';
import { postUser, updateUser } from 'projects/access-control/src/app/Infrastructure/Store/users/users.actions';
import { TranslateService } from '@mangosoft/mango-layout';
import { select, Store } from '@ngrx/store';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-gg';
import { Subscription } from 'rxjs';
import { ConfirmedValidator } from './confirmed.validator';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { RoleI } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { GeolocationService } from 'projects/access-control/src/app/Infrastructure/Services/geolocalitation/geolocation.service';

interface translateModalUser {
	name: string;
	nameGroup: string;
	nameUpdate: string;
	nameUpdateGroup: string;
	fullName: string;
	placeholderFullName: string;
	fullnameRequired: string;
	username: string;
	placeholderUsername: string;
	usernameRequired: string;
	email: string;
	placeholderEmail: string;
	emailRequired: string;
	phone: string;
	placeholderPhone: string;
	phoneRequired: string;
	phoneValid: string;
	password: string;
	placeholderPassword: string;
	passwordRequired: string;
	confirmPassword: string;
	placeholderConfirmPassword: string;
	confirmPasswordRequired: string;
	confirmPasswordNotMatch: string;
	groups: string;
	placeholderGroups: string;
	buttonSave: string;
	buttonCancel: string;
	status: string;
	placeholderStatus: string;
	statusRequired: string;
	usernameExists: string;
	phoneExists: string;
	emailExists: string;
	tabs: {
		general: string;
		groups: string;
		profile: string;
	};
	headerKey: string;
	headerValue: string;
	buttonAdd: string;
	placeholderKey: string;
	placeholderValue: string;
}
interface GroupsNode {
	name: any;
	children?: GroupsNode[];
}
interface GroupsFlatNode {
	expandable: boolean;
	name: AllGroupsI;
	level: number;
}

@Component({
	selector: 'app-modal-users',
	templateUrl: './modal-users.component.html',
	styleUrls: ['./modal-users.component.scss'],
})
export class ModalUsersComponent implements OnInit, OnDestroy {
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	separateDialCode = false;
	PhoneNumberFormat = PhoneNumberFormat;
	selectedCountryISO = CountryISO.UnitedStates;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Colombia];
	formUser!: FormGroup;
	formProfile!: FormGroup;

	groups: AllGroupsI[] = [];
	groupsSelected: AllGroupsI[] = [];
	groupsSelectedTwo: AllGroupsI[] = [];
	subscriptionGroups!: Subscription;
	status: StatusUSerGroups[] = [];
	translateModal: translateModalUser = {} as translateModalUser;
	subscriptionTranslate!: Subscription;
	stateUsername = false;
	statePhone = false;
	stateEmail = false;
	tab: string = '1';
	private _transformer = (node: GroupsNode, level: number) => {
		return {
			expandable: !!node.children && node.children.length > 0,
			name: node.name,
			level: level,
		};
	};

	treeControl = new FlatTreeControl<GroupsFlatNode>(
		(node) => node.level,
		(node) => node.expandable
	);

	treeFlattener = new MatTreeFlattener(
		this._transformer,
		(node) => node.level,
		(node) => node.expandable,
		(node) => node.children
	);
	dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

	constructor(
		private store: Store,
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<ModalUsersComponent>,
		private translate: TranslateService,
		private validates: ValidateExistenceService,
		private geoLocation: GeolocationService,
		@Inject(MAT_DIALOG_DATA) public data: { type: string; group: Groups; user: UsersGroups }
	) {
		// this.dataSource.data = this.groupsSelected;
	}
	hasChild = (_: number, node: GroupsFlatNode) => node.expandable;

	ngOnInit(): void {
		this.initModalUsers();
	}

	get f() {
		return this.formUser.controls;
	}

	initModalUsers() {
		this.geoLocation.getGeolocation().subscribe((resp: any) => {
			this.selectedCountryISO = resp.country_iso.toLowerCase();
		});

		this.formUser = this.formBuilder.group(
			{
				fullName: [this.data.user.fullName, [Validators.required]],
				username: [this.data.user.username, [Validators.required]],
				email: [this.data.user.email, [Validators.required, Validators.email]],
				phone: [this.data.user.phone],
				status: [{}, []],
				password: [
					this.data.user.password,
					[
						Validators.minLength(this.data.group.policy?.lenght_pass || 4),
						Validators.pattern(
							this.data.group.policy?.special_chars
								? this.getRegex(this.data.group.policy?.lenght_pass || 4)
								: ''
						),
					],
				],
				confirmPassword: [
					this.data.user.password,
					[
						Validators.minLength(this.data.group.policy?.lenght_pass || 4),
						Validators.pattern(
							this.data.group.policy?.special_chars
								? this.getRegex(this.data.group.policy?.lenght_pass || 4)
								: ''
						),
					],
				],
			},
			{
				validator: ConfirmedValidator('password', 'confirmPassword'),
			}
		);
		this.initFormProfile();
		setTimeout(() => {
			this.dataTranslate();
			if (this.data.type === 'updateGlobalUser' || this.data.type === 'newUserGlobal') {
				this.tab = '1';
				this.formUser.controls['status'].disable();
				this.store.dispatch(getAllGroup());
				this.getAllGroups();
			} else {
				this.formUser.controls['status'].setValidators([Validators.required]);
				this.status = this.data.group.statusUser;

				if (this.data?.user?.groups) {
					const groupUser: GroupsUsers = this.data?.user.groups[0] as GroupsUsers;
					const status = this.status.find(
						(nameStatus) => nameStatus.name === groupUser?.status || ''
					);
					this.formUser.controls['status'].patchValue(status);
				}
				this.formUser.controls['status'].updateValueAndValidity();
			}
			if (this.data.type === 'updateUser' || this.data.type === 'updateGlobalUser') {
				this.formUser.controls['email'].disable();
				this.formUser.controls['username'].disable();
			} else {
				this.formUser.controls['password'].setValidators([
					Validators.required,
					Validators.minLength(this.data.group.policy?.lenght_pass || 4),
					Validators.pattern(
						this.data.group.policy?.special_chars
							? this.getRegex(this.data.group.policy?.lenght_pass || 4)
							: ''
					),
				]);
				this.formUser.controls['confirmPassword'].setValidators([
					Validators.required,
					Validators.minLength(this.data.group.policy?.lenght_pass || 4),
					Validators.pattern(
						this.data.group.policy?.special_chars
							? this.getRegex(this.data.group.policy?.lenght_pass || 4)
							: ''
					),
				]);
				this.formUser.controls['password'].updateValueAndValidity();
				this.formUser.controls['confirmPassword'].updateValueAndValidity();
			}
		});
	}

	getAllGroups() {
		this.subscriptionGroups = this.store.pipe(select(selectGroupState)).subscribe(({ groups }) => {
			const allGroups = groups as AllGroupsI[];
			if (allGroups.length > 0) {
				this.groups = allGroups.filter((item) => item.sk !== '01GD47Q3JT8Y0WPTG37QGBERX0:current');

				if (this.data.type === 'updateGlobalUser') {
					this.groupsSelected = [];
					const groupsUsers: GroupsUsers[] = this.data.user.groups as GroupsUsers[];
					groupsUsers.forEach((itemGroups) => {
						const group = this.groups.find(
							(groupItem) => groupItem.pk === itemGroups.pk && groupItem.sk === itemGroups.sk
						);
						if (group?.sk) {
							this.groupsSelected.push(group);
							this.groupsSelectedTwo.push({
								...group,
								status: { color: itemGroups.color, name: itemGroups.status },
							});
						}
					});
					this.validateGroups();
				}
			}
		});
	}

	save() {
		let profile: any = {};
		const data: { key: string; value: string }[] = this.fields.value;
		data.forEach((item) => {
			profile[item.key.toLowerCase().trim()] =
				typeof item.value === 'string' ? item.value.trim() : item.value;
		});
		const { confirmPassword, status, phone, ...userData } = this.formUser.getRawValue();
		let idsGroups: GroupsUsers[] = [];
		this.groupsSelectedTwo.forEach((groupItem) => {
			idsGroups.push({
				pk: groupItem.pk,
				sk: groupItem.sk,
				status: groupItem.status.name,
				color: groupItem.status.color,
			});
		});

		const user: UsersGroups = {
			...userData,
			profile,
			username: userData.username.trim(),
			modifyGroups: this.data.type === 'updateGlobalUser' ? true : false,
			modifyStatus: this.data.type === 'updateUser' ? true : false,
			phone: phone && phone?.e164Number ? phone?.e164Number : '',
			groups:
				this.data.type === 'newUser' || this.data.type === 'updateUser'
					? [
							{
								pk: this.data.group.pk,
								sk: this.data.group.sk,
								status: status.name,
								color: status.color,
							},
					  ]
					: idsGroups,
		};
		if (this.data.type === 'newUser') {
			//Group User
			this.store.dispatch(postUsersGroups({ user }));
		} else if (this.data.type === 'updateUser') {
			//Group user
			this.store.dispatch(
				updateUsersGroups({
					user,
					idsUser: { pk: this.data.user.pk, sk: this.data.user.sk },
				})
			);
		} else if (this.data.type === 'updateGlobalUser') {
			//Global update
			this.store.dispatch(
				updateUser({
					user,
					ids: { pk: this.data.user.pk, sk: this.data.user.sk },
				})
			);
		} else {
			//Global users
			this.store.dispatch(postUser({ user }));
		}
		this.dialogRef.close();
	}

	getRegex(length: number): string {
		return `(?=.*[A-Z])(?=.*[!@#$&/*.)(?¡¿!°|'}+{-])(?=.*[0-9])(?=.*[a-z]).{${length},}`;
	}

	validateUsername(e: any) {
		this.validates.validateUsername(e.target.value).subscribe((resp) => {
			this.stateUsername = resp.elementFind;
		});
	}

	validateEmail(e: any) {
		this.validates.validateEmail(e.target.value).subscribe((resp) => {
			this.stateEmail = resp.elementFind;
		});
	}

	validatePhone(e: any) {
		if (this.data.type === 'newUserGlobal' || this.data.type === 'newUser') {
			let phone = this.formUser.value.phone ? this.formUser.value.phone.e164Number : '+1';
			phone = phone.length === 0 ? '1' : phone.slice(1);
			this.validates.validatePhone(phone).subscribe((resp) => {
				this.statePhone = resp.elementFind;
			});
		}
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.components.modalUsers;
		});
	}

	validateGroups(group: AllGroupsI = {} as AllGroupsI, node: StatusUserI = {} as StatusUserI) {
		this.groupsSelectedTwo = this.groupsSelected.map((groupSelected) => {
			const indexGroup = this.groupsSelectedTwo.findIndex(
				(groupItem) => groupItem.pk === groupSelected.pk && groupItem.sk === groupSelected.sk
			);
			if (indexGroup != -1) {
				return this.groupsSelectedTwo[indexGroup];
			}
			return groupSelected;
		});

		this.dataSource.data = this.groupsSelected.map((resp) => {
			let children: StatusUserI = { roles: [] as RoleI[] } as StatusUserI;
			if (group?.pk === resp.pk && group.sk === resp.sk) {
				children = node;
			} else {
				const groupTwo = this.groupsSelectedTwo.findIndex(
					(groupSelectedTwo) => groupSelectedTwo.pk === resp.pk && groupSelectedTwo.sk === resp.sk
				);

				if (groupTwo > -1) {
					// children = this.groupsSelectedTwo[groupTwo].statusUser.;
					children = resp.statusUser.find(
						(status) => status.name === this.groupsSelectedTwo[groupTwo].status.name
					) as StatusUserI;
				} else {
					if (!this.data.user.groups) {
						//Asigno valor del status open
						children = resp.statusUser.find((status) => status.name == 'open') as StatusUserI;
					} else {
						//Si esta modificando el usuario
						const globalUser = this.data.user.groups as GroupsUsers[];
						const group = globalUser.find(
							(groupIElement) => groupIElement.pk === resp.pk && groupIElement.sk === resp.sk
						);
						children = resp.statusUser.find(
							(statusUser) => statusUser.name === group?.status
						) as StatusUserI;
						if (!children?.name) {
							children = resp.statusUser.find((status) => status.name == 'open') as StatusUserI;
						}
					}
				}
			}

			return {
				...resp,
				name: resp,
				children: [children].map((respStatus) => {
					return {
						...respStatus,
						name: { ...respStatus, statusUser: resp.statusUser, resp },
						children: !respStatus?.roles
							? []
							: respStatus?.roles.map((role) => {
									return {
										...role,
										name: role,
										children: !role?.resources
											? []
											: role.resources.map((resource) => {
													return {
														...resource,
														name: resource,
													};
											  }),
									};
							  }),
					};
				}),
			};
		});
	}

	elementSelected(node: StatusUserI, group: AllGroupsI) {
		this.groupsSelectedTwo = this.groupsSelected.map((groupItem) => {
			const groupSelectedTwo = this.groupsSelectedTwo.find(
				(groupSelectedTwoItem) =>
					groupSelectedTwoItem.pk == groupItem.pk && groupItem.sk == groupSelectedTwoItem.sk
			);
			if (groupSelectedTwo?.pk && groupSelectedTwo.sk !== group.sk) {
				return { ...groupSelectedTwo };
			}

			if (groupItem.pk === group.pk && groupItem.sk === group.sk) {
				return { ...groupItem, status: { color: node.color, name: node.name } };
			}
			return { ...groupItem };
		});
		this.validateGroups(group, node);
	}

	initFormProfile() {
		this.formProfile = this.formBuilder.group({
			profile: this.formBuilder.array([]),
		});
		if (this.data?.user && this.data?.user?.profile) {
			Object.keys(this.data?.user?.profile).forEach((key) => {
				this.fields.push(
					this.formBuilder.group({
						key: [key, Validators.required],
						value: [this.data?.user.profile[key], Validators.required],
					})
				);
			});
		}
	}

	removeField(index: number) {
		this.fields.removeAt(index);
	}
	addField() {
		this.fields.push(
			this.formBuilder.group({
				key: ['', Validators.required],
				value: ['', Validators.required],
			})
		);
	}

	get form(): {
		[key: string]: AbstractControl;
	} {
		return this.formProfile.controls;
	}

	get fields() {
		return this.formProfile.get('profile') as FormArray;
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
		this.subscriptionGroups?.unsubscribe();
	}
}
